import Axios from 'axios';
import { FetchRequest } from '@rails/request.js';
import '../stylesheets/admin.css';

Axios.defaults.headers.common['X-CSRF-Token'] = new FetchRequest('', '').csrfToken;
